export const USPS_LINK =
  'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1='
export const UPS_LINK =
  'http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums='
export const FEDEX_LINK = 'http://www.fedex.com/Tracking?tracknumbers='
